"use client"

import { atom } from 'jotai';
import { MediaState } from "@/types/types.ts";

export const mediaStateAtom = atom(MediaState.PAUSED);
